export default __webpack_public_path__ + "static/media/WelcomeToNuleep.30791dcf.png";